export default __webpack_public_path__ + "static/media/Q06_渾厚濃郁、奶油般綿密質地.fabb92ac.mp4";